import { render, staticRenderFns } from "./BlackView.vue?vue&type=template&id=d3d96f58&scoped=true"
import script from "./BlackView.vue?vue&type=script&lang=js"
export * from "./BlackView.vue?vue&type=script&lang=js"
import style0 from "./BlackView.vue?vue&type=style&index=0&id=d3d96f58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d96f58",
  null
  
)

export default component.exports